<template>
  <div>
    <b-navbar toggleable="lg" class="nav-bottom">
      <b-navbar-toggle target="navbar" v-if="navbottomStatus"></b-navbar-toggle>
      <b-collapse id="navbar" is-nav v-if="navbottomStatus">
        <b-navbar-nav>
          <b-nav-item-dropdown text="ประเภทรายการข้อมูล" left v-if="role">
            <b-dropdown-item router-link to="/sandreport">ข้อมูลรายการทราย</b-dropdown-item>
            <b-dropdown-item router-link to="/stondreport">ข้อมูลรายการหิน</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <em>
                <font-awesome-icon icon="user-alt" />
                &nbsp;&nbsp;{{username}}
              </em>
            </template>
            <b-dropdown-item @click="logout" href="#">ออกจากระบบ</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: null,
      navbottomStatus: false,
      role: false
    };
  },
  mounted() {
    this.$session.start()
    if (window.location.hash !== "#/" && this.$session.get("name") === undefined) {
      this.$router.push("/");
      alert(1);
    } else if (window.location.hash === "#/") {
      this.navbottomStatus = false;
    } else {
      this.navbottomStatus = true;
      this.username = this.$session.get("name");
      if(this.$session.get("name") === "admin"){
        this.role = true
      }else{
        this.role =false
      }
    }
  },
  methods: {
    logout: function() {
      this.$session.destroy();
      this.$router.push("/");
    }
  }
};
</script>

<style>
.nav-link {
  color: white !important;
}
.nav-top {
  background-color: #0000FF;
  height: 70px;
  font-family: "Taviraj" !important;
}
.nav-bottom {
  font-family: "Taviraj" !important;
  background-color: rgb(255, 0, 0);
}

.nav-item a.nav-link:hover {
  background-color: rgb(27, 27, 27);
  border-radius: 20px;
  color: white !important;
}
.dropdown a {
  font-weight: bold !important;
}
.navbar-toggler {
  border-color: white !important;
  border: 1px solid #fff !important;
}
.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='white' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
}

.dropdown-menu {
  background-color: rgba(156, 155, 153, 0.924) !important;
}

.dropdown-menu a {
  color: white !important;
}

.dropdown-menu a:hover {
  background-color: #0905ff !important;
  color: white !important;
}
</style>
